import {redirectToHRMProfile} from '@innowise-group/utilities';
import {useEffect, useState} from 'react';
import * as Styled from './avatar.styles';
import unknownUserLogo from '../../../assets/icons/unknown-user-logo.svg';

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  badge?: React.ReactNode;
  hrmId?: string;
  imageUrl: string;
  size?: number;
  withTooltip?: boolean;
}

async function cropAndResizeImage(url: string, size: number): Promise<string> {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = size * 2;
      canvas.height = size * 2;
      const ctx = canvas.getContext('2d');

      if (!ctx) return;

      const minSide = Math.min(img.width, img.height);

      const sx = (img.width - minSide) / 2;
      const sy = (img.height - minSide) / 2;

      ctx.drawImage(img, sx, sy, minSide, minSide, 0, 0, canvas.width, canvas.height);

      resolve(canvas.toDataURL('image/png'));
    };
    img.src = url;
  });
}

const Avatar: React.FC<AvatarProps> = ({imageUrl, hrmId, badge = null, size = 40, withTooltip = false, ...props}) => {
  const [isError, setIsError] = useState(false);
  const onError = () => setIsError(true);

  const handleAvatarClick = () => {
    hrmId && redirectToHRMProfile(hrmId);
  };

  const [optimizedUrl, setOptimizedUrl] = useState<string>();

  useEffect(() => {
    cropAndResizeImage(imageUrl, size).then(setOptimizedUrl);
  }, [imageUrl, size]);

  return (
    <Styled.AvatarWrapper onClick={handleAvatarClick} {...props} withTooltip={withTooltip}>
      <Styled.Avatar
        onError={onError}
        src={isError ? unknownUserLogo : optimizedUrl || imageUrl}
        style={{width: size, height: size}}
      />
      <Styled.BadgeContainer>{badge}</Styled.BadgeContainer>
    </Styled.AvatarWrapper>
  );
};

export default Avatar;
